var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"options":[
      { type: 'date', label: '점검일'},
      { type: 'text', label: '점검장소'},
      { type: 'disaster', label: '재해형태'}
    ],"board":this.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('file-upload-module',{staticClass:"w-full mt-4",attrs:{"id":"fileList","is-print":_vm.isPrint,"readonly":_vm.board.readonly},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }